import Select from "react-select";

const ConfigDropdown = ({ configs, selectedId, handleSelect }) => {
  // Convert API data → react-select format
  const options = configs.map((cfg) => ({
    value: cfg.id,
    label: cfg.configName,
  }));

  const selectedOption = options.find(opt => opt.value === selectedId) || null;

  return (
    <div className="bg-white border rounded-xl p-5">
      <label className="block text-sm font-semibold mb-2">
        Select Configuration
      </label>

      <Select
        options={options}
        value={selectedOption}
        onChange={(option) => handleSelect(option?.value || "")}
        placeholder="-- Select Config --"
        isSearchable
        className="text-sm"
        isClearable
      />
    </div>
  );
};

export default ConfigDropdown;